// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U3WK","type":"styles_type__23byZ","choices":"styles_choices__To3mL"};